module.exports = __webpack_public_path__ + "static/img/son2_active.7014aad5.png";